import TicketDetailEarlyMobile from '~/shared/assets/images/ticket-detail-early-mobile.png'
import TicketDetailEarlyPc from '~/shared/assets/images/ticket-detail-early-pc.png'
import TicketDetailGgufMobile from '~/shared/assets/images/ticket-detail-gguf-mobile.png'
import TicketDetailGgucPc from '~/shared/assets/images/ticket-detail-gguf-pc.png'
import TicketDetailNormalMobile from '~/shared/assets/images/ticket-detail-normal-mobile.png'
import TicketDetailNormalPc from '~/shared/assets/images/ticket-detail-normal-pc.png'
import TicketEarlyMobile from '~/shared/assets/images/ticket-early-mobile.png'
import TicketEarlyPc from '~/shared/assets/images/ticket-early-pc.png'
import TicketGgufMobile from '~/shared/assets/images/ticket-gguf-mobile.png'
import TicketGgufPc from '~/shared/assets/images/ticket-gguf-pc.png'
import TicketNormalMobile from '~/shared/assets/images/ticket-normal-mobile.png'
import TicketNormalPc from '~/shared/assets/images/ticket-normal-pc.png'

export const getTicketTypeBackgroundColor = (code: string) => {
  switch (code) {
    case 'E0200001':
      return '#8BD2D7'
    case 'E0200002':
      return '#F7B6CC'
    case 'E0200003':
      return '#F6C04B'
    default:
      return '#FFFFFF'
  }
}

export const getTicketAmountColor = (code: string) => {
  switch (code) {
    case 'E0200001':
      return '#8BD2D7'
    case 'E0200002':
      return '#F7B6CC'
    case 'E0200003':
      return '#F6C04B'
    default:
      return '#FFFFFF'
  }
}

export const getTicketAmountBackgroundColor = (code: string) => {
  switch (code) {
    case 'E0200001':
      return '#C6E6E8'
    case 'E0200002':
      return '#F6D9E3'
    case 'E0200003':
      return '#FDE1A5'
    default:
      return '#FFFFFF'
  }
}

export const getTicketBackgroundImage = (
  code: string,
  isMobile: boolean,
): string => {
  switch (code) {
    case 'E0200001':
      return isMobile ? TicketGgufMobile : TicketGgufPc
    case 'E0200002':
      return isMobile ? TicketEarlyMobile : TicketEarlyPc
    case 'E0200003':
      return isMobile ? TicketNormalMobile : TicketNormalPc
    default:
      return isMobile ? TicketGgufMobile : TicketGgufPc
  }
}

export const getTicketDetailBackgroundImage = (
  code: string,
  isMobile: boolean,
): string => {
  switch (code) {
    case 'E0200001':
      return isMobile ? TicketDetailGgufMobile : TicketDetailGgucPc
    case 'E0200002':
      return isMobile ? TicketDetailEarlyMobile : TicketDetailEarlyPc
    case 'E0200003':
      return isMobile ? TicketDetailNormalMobile : TicketDetailNormalPc
    default:
      return isMobile ? TicketDetailNormalMobile : TicketDetailNormalPc
  }
}
